import { render, staticRenderFns } from "./studentOnlyReadDialog.vue?vue&type=template&id=e47a46c4&"
import script from "./studentOnlyReadDialog.vue?vue&type=script&lang=js&"
export * from "./studentOnlyReadDialog.vue?vue&type=script&lang=js&"
import style0 from "./studentOnlyReadDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports